import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function checkDossier(demande) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.checkDossier,
    urlConfig: {
      pathParams: {
        numeroanfr: demande.suivieAuthent.identifiant,
        nom: demande.suivieAuthent.nom,
        prenom: demande.suivieAuthent.prenom
      }
    }
  }).then(r => r.data);
}

function checkFactureDossier(demande) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.checkDossier,
    urlConfig: {
      pathParams: {
        numeroanfr: demande.numeroAnfr,
        nom: demande.prtvInterface6.nom,
        prenom: demande.prtvInterface6.prenom
      }
    }
  }).then(r => r.data);
}

export default {
  checkDossier,
  checkFactureDossier
};



// WEBPACK FOOTER //
// ./src/repositories/suivie-dossier.repository.js